'use strict';


var novicell = novicell || {};
var defaultPortfolioId = defaultPortfolioId || null;
var umbPortFolioData = umbPortFolioData || null;
var umbPortFolioKidsData = umbPortFolioKidsData || null;
var configInformation = configInformation || null;

novicell.calculator = novicell.calculator || new function () {
    var mainColorRGB = '0, 104, 144';
    var arrMainColorOpacities = ['1', '0_5'];
    var objMainColorsRgba = {};

    this.setColors = function (graphContainer) {
        // color for graphs = button color

        let testButton = document.createElement('button');
        testButton.id = 'js-testButton';
        testButton.classList.add('theme-button');
        testButton.setAttribute('style', 'position:fixed;left:-3333px;');
        graphContainer.appendChild(testButton);
        let colorString = getComputedStyle(document.getElementById('js-testButton')).backgroundColor;
        colorString = colorString.replace('rgb(', '');
        colorString = colorString.replace(')', '');
        mainColorRGB = colorString;
        for (var i = 0; i < arrMainColorOpacities.length; i++) {
            var thisOpacity = arrMainColorOpacities[i].replace('_', '.');
            objMainColorsRgba['o' + arrMainColorOpacities[i]] = 'rgba(' + mainColorRGB + ',' + thisOpacity + ')';
        }
    };
    this.init = function () {
        const graphContainer = document.getElementById('js-savings-graph-container');
        if (graphContainer == null) {
            return;
        }
        this.setColors(graphContainer);

        Vue.component('line-chart', {
            extends: VueChartJs.Line,
            mixins: [VueChartJs.mixins.reactiveProp],
            props: ['chartData', 'options'],
            mounted() {
                // this.chartData is created in the mixin
                this.renderChart(this.chartData, this.options);
            }
        });

        new Vue({
            el: graphContainer,
            props: ['chartData', 'options', 'inputId'],
            data: {
                riscDefaultValue: defaultPortfolioId,/* defaultPortfolioId is set in the razor file */
                tableDataNotFormatted: {},/*data for table under chart, numbers without unit and thousand separator*/
                controllersOptionsGeneral: {/*options for sliders - options they all have in common */
                    data: null,
                    eventType: 'auto',
                    width: 'auto',
                    height: 6,
                    dotSize: 16,
                    dotHeight: null,
                    dotWidth: null,
                    interval: 1,
                    show: true,
                    speed: 0.5,
                    disabled: false,
                    piecewise: false,
                    usdKeyboard: false,
                    enableCross: true,
                    piecewiseLabel: false,
                    piecewiseActiveStyle: null,
                    tooltip: 'hover',
                    tooltipDir: 'top',
                    reverse: false,
                    clickable: true,
                    realTime: false,
                    lazy: false,
                    formatter: null,
                    sliderStyle: null,
                    labelStyle: null,
                    labelActiveStyle: null,
                    bgStyle: {
                        "backgroundColor": "#f2f2f2",
                    },
                    tooltipStyle: {
                        "backgroundColor": objMainColorsRgba.o1,
                        "borderColor": objMainColorsRgba.o1,
                        'padding': '0 3px',
                        'lineHeight': 1.3
                    },
                    processStyle: {
                        "backgroundColor": objMainColorsRgba.o1
                    }
                },
                savingsGraphType: 'pension',/* pension or kids */
                portfolios: [],/**will contain the portfolios, for instance KontoInvest 55 data */
                lineChartLabels: [],/**labels for the chart */
                lineChartData: [],
                hasBeenUpdated: false,/**values for the chart */
                _controllers: {}
            },
            mixins: [VueChartJs.mixins.reactiveProp],
            created() {
                this.loadConfigData();
            },
            mounted() {
                this.makePortFolios();/**put data in this.portfolios */
                this.sliderChange(true);/**trigger slider change to draw chart with real data */
            },
            computed: {
                riscDefaultValueIndex: function () {
                    var thisIndex = -1;

                    for (var i = 0; i < this.portfolioData.length; ++i) {
                        if (this.portfolioData[i].id == this.riscDefaultValue) {
                            thisIndex = i;
                            break;
                        }
                    }
                    return thisIndex;
                },
                graphOptions: function () {/*options for line chart */
                    let self = this;
                    let obj = {

                        responsive: true,
                        animation: {
                            duration: 900
                        },
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true,
                                    callback: function (value, index, values) {
                                        let valuePrefix = value > 0 ? '+' : '';
                                        return self.formatFloatToDanishInt(value) + ' kr. ';
                                    },
                                },
                                gridLines: {
                                    drawBorder: false,
                                    color: '#eee'
                                }
                            }],
                            xAxes: [{
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    fontSize: 11,
                                    fontColor: '#b3b1b3'
                                }
                            }]
                        },
                        legend: {
                            display: false
                        },
                        layout: {
                            padding: {
                                top: 5
                            }
                        },
                        tooltips: {
                            enabled: false,

                            custom: function (tooltipModel) {
                                var tooltipEl = document.getElementById('chartjs-tooltip');

                                var innerHtml = '';

                                // Create element on first render
                                if (!tooltipEl) {
                                    tooltipEl = document.createElement('div');
                                    tooltipEl.id = 'chartjs-tooltip';
                                    tooltipEl.innerHTML = "<div></div>";
                                    document.body.appendChild(tooltipEl);
                                }

                                // Hide if no tooltip
                                if (tooltipModel.opacity === 0) {
                                    tooltipEl.style.opacity = 0;
                                    return;
                                }

                                // Set caret Position
                                tooltipEl.classList.remove('above', 'below', 'no-transform');
                                if (tooltipModel.yAlign) {
                                    tooltipEl.classList.add(tooltipModel.yAlign);
                                } else {
                                    tooltipEl.classList.add('no-transform');
                                }

                                function getBody(bodyItem) {
                                    return bodyItem.lines;
                                }

                                // Set Text
                                if (tooltipModel.body) {
                                    var titleLines = tooltipModel.title || [];
                                    var bodyLines = tooltipModel.body.map(getBody);

                                    bodyLines.forEach(function (body, i) {//value
                                        body = body[0] * 1;
                                        var float = Math.round(body);
                                        var string = float.toString();
                                        string = string.replace(/\B(?=(\d{3})+(?!\d))/g, '#');
                                        string = string.replace(/\./g, ',');
                                        string = string.replace(/#/g, '.');
                                        //GREY TOOLTIP innerHtml += '<span style="left: calc(50% - 10px);display:block;position:absolute;top:100%;width: 0;height: 0;border-style: solid;border-width: 10px 10px 0 10px;border-color: #b3b1b3 transparent transparent transparent;"></span><b style="display:block;font-size:15px;">' + string + ' kr.</b>';
                                        innerHtml += '<span style="left: calc(50% - 10px);display:block;position:absolute;top:100%;width: 0;height: 0;border-style: solid;border-width: 10px 10px 0 10px;border-color: ' + objMainColorsRgba.o1 + ' transparent transparent transparent;"></span><b style="display:block;font-size:15px;">' + string + ' kr.</b>';
                                    });

                                    titleLines.forEach(function (title) {
                                        innerHtml += '<span style="display:block;font-size:13px;">' + title + ' år</span>';
                                    });

                                    var tableRoot = tooltipEl.querySelector('div');
                                    tableRoot.innerHTML = innerHtml;
                                }

                                // `this` will be the overall tooltip
                                var position = this._chart.canvas.getBoundingClientRect();

                                // Display, position, and set styles for font
                                tooltipEl.style.opacity = 1;
                                tooltipEl.style.position = 'absolute';
                                tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                                tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                                tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                                tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
                                tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                                tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                                //GREY TOOLTIP tooltipEl.style.background = '#b3b1b3';
                                tooltipEl.style.background = objMainColorsRgba.o1;
                                tooltipEl.style.WebkitTransform = 'translate(-50%,-100%)';
                                tooltipEl.style.transform = 'translate(-50%,-100%)';
                                tooltipEl.style.margin = '-20px 0 0 0';
                                tooltipEl.style.borderRadius = '3px';
                                tooltipEl.style.textAlign = 'center';
                                tooltipEl.style.padding = '3px 5px';
                                tooltipEl.style.pointerEvents = 'none';
                                tooltipEl.style.color = '#fff';

                            }
                        }
                    };
                    return obj;
                },
                vueSliderOptionsinitialDeposit: function () {
                    /**a hack because I can't use the spread operator on objects, had to make a computed property for each slider.. */
                    var copy = Object.assign({}, this.controllersOptionsGeneral);
                    return Object.assign(copy, this.controllers.initialDeposit.customOptions);
                },
                vueSliderOptionsyearlyDeposit: function () {
                    /**a hack because I can't use the spread operator on objects, had to make a computed property for each slider.. */
                    var copy = Object.assign({}, this.controllersOptionsGeneral);
                    return Object.assign(copy, this.controllers.yearlyDeposit.customOptions);
                },
                vueSliderOptionsrisc: function () {
                    /**a hack because I can't use the spread operator on objects, had to make a computed property for each slider.. */
                    var copy = Object.assign({}, this.controllersOptionsGeneral);
                    return Object.assign(copy, this.controllers.risc.customOptions);
                },
                vueSliderOptionslifeTime: function () {
                    /**a hack because I can't use the spread operator on objects, had to make a computed property for each slider.. */
                    var copy = Object.assign({}, this.controllersOptionsGeneral);
                    return Object.assign(copy, this.controllers.lifeTime.customOptions);
                },
                nameOfChosenProduct: function () {
                    var productName = this.productNames[this.riscDefaultValueIndex];
                    return productName;
                },
                tableData: function () {/**format table data, add unit and thousand separator etc. */
                    const kr = ' kr.';
                    const percent = ' %';
                    let obj = {};

                    var productName = this.productNames[this.riscDefaultValueIndex];
                    const savingstype = this._data.savingsGraphType == 'pension' ? 'Pension' : 'Børneopsparing';
                    obj.productName = {
                        name: 'Produkt',
                        value: this.controllers.risc.startValue
                    };
                    obj.savingsType = {
                        name: 'Opsparingsform',
                        value: savingstype
                    };
                    obj.totalDeposit = {
                        name: 'Samlet indskud',
                        value: this.formatFloatToDanishInt(this.tableDataNotFormatted.TotalDeposit) + kr
                    };
                    obj.totalGains = {
                        name: 'Forventet afkast',
                        value: this.formatFloatToDanishInt(this.tableDataNotFormatted.TotalGains) + kr
                    };
                    obj.yearlyCostsInPercentage = {
                        name: 'Løbende omk. *',
                        value: this.formatFloatToDanishFloat(this.tableDataNotFormatted.YearlyCostsInPercentage * 100) + percent
                    };
                    obj.firstYearCostsPercentage = {
                        name: 'Første år<br>omk. %',
                        value: this.formatFloatToDanishFloat(this.tableDataNotFormatted.FirstYearCostsPercentage * 100) + percent
                    };
                    obj.firstYearCosts = {
                        name: 'Første år<br>omk. kr.',
                        value: this.formatFloatToDanishInt(this.tableDataNotFormatted.FirstYearCosts) + kr
                    };
                    obj.avgYearlyCosts = {
                        name: 'Gns. årlige omk.',
                        value: this.formatFloatToDanishInt(this.tableDataNotFormatted.AvgYearlyCosts) + kr
                    };
                    obj.totalTax = {
                        name: 'Skat',
                        value: this.formatFloatToDanishInt(this.tableDataNotFormatted.TotalTax) + kr
                    };
                    obj.endBalance = {
                        name: 'Forventet <br>slutformue',
                        value: this.formatFloatToDanishInt(this.tableDataNotFormatted.EndBalance) + kr
                    };
                    /* obj.totalCosts = {
                        name:'Omkostninger',
                        value: this.formatFloatToDanishInt(this.tableDataNotFormatted.TotalCosts)+kr
                    }; */
                    return obj;
                },
                portfolioData: function () {/**switch between data for kids and pension savings */
                    if (this.savingsGraphType == 'pension') {
                        return umbPortFolioData;
                    }
                    return umbPortFolioKidsData;
                },
                graphData: function () {/**data for chart (labels and values) */
                    let obj = {
                        labels: this.lineChartLabels,
                        datasets: [{
                            data: this.lineChartData,
                            backgroundColor: objMainColorsRgba.o0_5,
                            borderColor: objMainColorsRgba.o1,
                            borderWidth: 2,
                            pointBackgroundColor: objMainColorsRgba.o1,
                            pointBorderWidth: 0,
                            pointRadius: 3,
                            lineTension: 0
                        }]
                    };
                    return obj;
                },
                productNames: function () {
                    /** make array of product name, for instance "KontoInvest 55" */
                    return this.portfolioData.map(function (item) { return item.name; });
                },
                controllers: function () {
                    return this._data._controllers[this._data.savingsGraphType];
                },
                isOverMax: function () {
                    if (this.controllers.totalDeposit.errorText === "undefined" || this.controllers.totalDeposit.max === -1) {
                        return false;
                    }
                    return this.tableDataNotFormatted.TotalDeposit > this.controllers.totalDeposit.customOptions.max;
                }

            },
            methods: {
                loadConfigData: function () {
                    for (var config in configInformation) {
                        this._data._controllers[configInformation[config].key] = {
                            initialDeposit: {
                                label: 'Startindskud',
                                startValue: configInformation[config].initialDeposit.startValue,
                                unit: 'kr.',
                                inputId: 'startindskudKanAendres',
                                maxValueNotFixed: true,
                                shownMax: configInformation[config].initialDeposit.customOptions.max,
                                hiddenMax: 99999999999999999,
                                customOptions: {
                                    min: configInformation[config].initialDeposit.customOptions.min,
                                    max: configInformation[config].initialDeposit.customOptions.max,
                                    interval: configInformation[config].initialDeposit.customOptions.interval
                                }
                            },
                            yearlyDeposit: {
                                label: configInformation[config].yearlyDeposit.label,
                                useMonthlyPayment: configInformation[config].yearlyDeposit.useMonthlyPayment,
                                startValue: configInformation[config].yearlyDeposit.startValue,
                                unit: 'kr.',
                                inputId: 'aarligindbetalingKanAendres',
                                customOptions: {
                                    min: configInformation[config].yearlyDeposit.customOptions.min,
                                    max: configInformation[config].yearlyDeposit.customOptions.max,
                                    interval: configInformation[config].yearlyDeposit.customOptions.interval
                                }
                            },
                            risc: {
                                label: 'Risikovillighed',
                                defaultIndex: this.riscDefaultValueIndex,
                                startValue: this.productNames[this.riscDefaultValueIndex],
                                minValueText: 'Lav',
                                maxValueText: 'Meget høj',
                                inputId: 'risikovillighedKanAendres',
                                customOptions: {
                                    data: this.productNames
                                }
                            },
                            lifeTime: {
                                label: 'Løbetid',
                                startValue: configInformation[config].lifeTime.startValue,
                                unit: 'år',
                                inputId: 'loebetidKanAendres',
                                customOptions: {
                                    min: configInformation[config].lifeTime.customOptions.min,
                                    max: configInformation[config].lifeTime.customOptions.max
                                }
                            },
                            totalDeposit: {
                                errorText: configInformation[config].totalDeposit.errorText,
                                customOptions: {
                                    max: configInformation[config].totalDeposit.customOptions.max
                                }
                            }
                        };
                    }
                },
                formatFloatToDanishFloat: function (float) {/**format number to have 2 decimals and use danish notation, for instance 3.456.789,01 */
                    float = float.toFixed(2);
                    var string = float.toString();
                    string = string.replace(/\B(?=(\d{3})+(?!\d))/g, '#');
                    string = string.replace(/\./g, ',');
                    string = string.replace(/#/g, '.');
                    return string;
                },
                formatFloatToDanishInt: function (float) {/**round number to integer and use danish notation, for instance 3.456.789,01 */
                    float = Math.round(float);
                    var string = float.toString();
                    string = string.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                    return string;
                },
                switchGraphType: function () {/**when you switch between kids and pension you have to update data and graph */
                    this.makePortFolios();
                    this.sliderChange(true);
                },
                makePortFolios: function () {/**make portfolios for each product, for instance for KontoInvest 55 */
                    let arr = [];
                    for (let i = 0; i < this.portfolioData.length; i++) {
                        let obj = {};
                        let currentData = this.portfolioData[i];

                        obj.Name = currentData.name;
                        obj.returnLTE5 = currentData.lte5;
                        obj.returnGT5LTE10 = currentData.gt5lte10;
                        obj.returnGT10 = currentData.gt10;
                        obj.BaseCost = currentData.baseCost;
                        obj.FeesLadder = [
                            { LadderMin: 0, LadderMax: currentData.feeStep1UpperBoundary, Cost: currentData.fee1 },
                            { LadderMin: currentData.feeStep1UpperBoundary, LadderMax: currentData.feeStep2UpperBoundary, Cost: currentData.fee2 },
                            { LadderMin: currentData.feeStep2UpperBoundary, LadderMax: 2000000000, Cost: currentData.fee3 }
                        ];
                        obj.Tax = currentData.tax;
                        obj.FeeMin = currentData.feeMin;
                        obj.FeeMax = currentData.feeMax;
                        obj.TransactionCosts = currentData.transactionCosts;
                        arr.push(obj);
                    }
                    this.portfolios = arr;
                },
                sliderChange(first) {/**when a slider changes */
                    if (typeof (first) !== "boolean") { this.hasBeenUpdated = true; }
                    for (var prop in this.controllers) {
                        let c = this.controllers[prop];
                        if (c.maxValueNotFixed) {
                            let value = c.startValue;
                            let dataMaxValue = c.shownMax;
                            if (this.controllers[prop].customOptions.max != value && dataMaxValue != value) {
                                if (value > dataMaxValue) {
                                    this.controllers[prop].customOptions.max = value;
                                    this.controllers[prop].startValue = value;
                                } else {
                                    this.controllers[prop].customOptions.max = dataMaxValue;
                                    this.controllers[prop].startValue = value;
                                }
                                for (var prop2 in this.controllers[prop].customOptions) {
                                    this.vueSliderOptionsinitialDeposit[prop2] = this.controllers[prop].customOptions[prop2];//I hardcoded the vueSliderOptionsinitialDeposit because so far it's the only one without a max-value
                                }
                            }
                        }
                    }
                    /**get the values from the sliders*/
                    let initialCapital = this.$children[0].val;
                    let yearlyDeposit = this.$children[1].val;
                    let portFolioIndex = this.productNames.indexOf(this.$children[2].val);
                    let portFolioName = this.$children[2].val;
                    let numberOfYears = this.$children[3].val;
                    if (first != 'fromInputField' && this.hasBeenUpdated) {
                        if (first === true) {/**first time you have to find values in another property.. */
                            initialCapital = this.$children[0].value;
                            yearlyDeposit = this.$children[1].value;
                            portFolioName = this.$children[2].value;
                            portFolioIndex = this.productNames.indexOf(this.$children[2].value);
                            numberOfYears = this.$children[3].value;
                        }

                        /**set startvalue and defaultindex to current values so the slidervalues remain if you change between kids savings and pension savings*/
                        this.controllers.initialDeposit.startValue = initialCapital;
                        this.controllers.yearlyDeposit.startValue = yearlyDeposit;
                        this.controllers.risc.startValue = portFolioName;
                        this.controllers.risc.defaultIndex = portFolioIndex;
                        this.controllers.lifeTime.startValue = numberOfYears;
                    } else {
                        initialCapital = this.controllers.initialDeposit.startValue;
                        yearlyDeposit = this.controllers.yearlyDeposit.startValue;
                        portFolioName = this.controllers.risc.startValue;
                        portFolioIndex = this.controllers.risc.defaultIndex;
                        numberOfYears = this.controllers.lifeTime.startValue;
                    }
                    /**parseint because sometimes the value comes from a input field and is a string*/
                    initialCapital = parseInt(initialCapital);
                    yearlyDeposit = parseInt(yearlyDeposit);
                    portFolioName = parseInt(portFolioName);
                    portFolioIndex = parseInt(portFolioIndex);
                    numberOfYears = parseInt(numberOfYears);

                    /**get and set values of graph*/
                    let savingsValues = this.calculate(initialCapital, yearlyDeposit, portFolioIndex, numberOfYears);
                    let label = 0;
                    let dataLabels = savingsValues.Years.map(function () { label++; return label; });
                    let dataValues = savingsValues.Years.map(function (item) { return item; });

                    /**show the updated data on graph and in table */
                    this.lineChartData = dataValues;
                    this.lineChartLabels = dataLabels;
                    this.tableDataNotFormatted = savingsValues;
                    delete this.tableDataNotFormatted.Years;
                },
                calculateYearly: function (portfolio, yearlyDeposit, primo, currentYear) {
                    //var avgBalanceOverTime = totals.AvgBalanceOverTime;
                    //var totalCostsOverTime = totals.TotalCostsOverTime;
                    //var totalGainsOverTime = totals.TotalGainsOverTime;
                    var calculatedYear = {};

                    var formuePrimo = primo;
                    calculatedYear.BalancePrimo = formuePrimo;

                    var indskud = yearlyDeposit;
                    calculatedYear.Deposit = indskud;

                    var primoFormueEfterIndskud = formuePrimo + indskud;
                    calculatedYear.BalanceAfterDeposit = primoFormueEfterIndskud;

                    var currentInterestPct = portfolio.returnLTE5;

                    if (currentYear > 5 && currentYear <= 10) {
                        currentInterestPct = portfolio.returnGT5LTE10;
                    }

                    if (currentYear > 10) {
                        currentInterestPct = portfolio.returnGT10;
                    }

                    var afkast = primoFormueEfterIndskud * currentInterestPct;
                    calculatedYear.Gains = afkast;

                    var formueFørOmkOgSkat = primoFormueEfterIndskud + afkast;
                    calculatedYear.BalancePreCostAndTax = formueFørOmkOgSkat;


                    var AvgBalance = ((primoFormueEfterIndskud + formueFørOmkOgSkat) / 2);
                    var omkKontoInvest = AvgBalance * portfolio.BaseCost;

                    calculatedYear.Costs = omkKontoInvest;

                    // PI-gebyr
                    var BiFeeLadder = new Array(portfolio.FeesLadder.length);
                    var BiFee = 0;

                    for (var i = 0; i < portfolio.FeesLadder.length; i++) {
                        var feeStep = portfolio.FeesLadder[i];

                        var stepValue;

                        if (AvgBalance > feeStep.LadderMax) {
                            stepValue = feeStep.LadderMax - feeStep.LadderMin;
                        } else if (AvgBalance < feeStep.LadderMin) {
                            stepValue = 0;
                        } else {
                            stepValue = AvgBalance - feeStep.LadderMin;
                        }

                        var costForStep = stepValue * feeStep.Cost;

                        BiFeeLadder[i] = costForStep;
                        BiFee = BiFee + costForStep;
                    }


                    if (BiFee < portfolio.FeeMin) {
                        BiFee = portfolio.FeeMin;
                    } else if (BiFee > portfolio.FeeMax && portfolio.FeeMax > 0) {
                        BiFee = portfolio.FeeMax;
                    }

                    calculatedYear.Fees = BiFee;

                    var omkIalt = omkKontoInvest + BiFee;
                    calculatedYear.TotalCosts = omkIalt;

                    var formueFørSkat = formueFørOmkOgSkat - omkIalt;
                    calculatedYear.BalancePreTax = formueFørSkat;

                    var taxBase = afkast - omkKontoInvest;
                    var palSkat = taxBase * portfolio.Tax;

                    calculatedYear.Tax = palSkat;

                    var accountUltimo = formueFørSkat - palSkat;
                    calculatedYear.Ultimo = accountUltimo;

                    var GensFormueIndeForÅret = AvgBalance;
                    calculatedYear.AvgBalanceMedio = GensFormueIndeForÅret;
                    return calculatedYear;
                },
                calculateMonthly: function (portfolio, termDeposit, primo, currentYear) {

                    var noOfTermPerYear = 12;
                    // Set used InterestPct
                    var currentInterestPct = portfolio.returnLTE5;
                    if (currentYear > 5 && currentYear <= 10) {
                        currentInterestPct = portfolio.returnGT5LTE10;
                    }

                    if (currentYear > 10) {
                        currentInterestPct = portfolio.returnGT10;
                    }
                    currentInterestPct = Math.pow((currentInterestPct+1) , (1/noOfTermPerYear)) -1;

                    var baseCost = Math.pow((portfolio.BaseCost+1) , (1/noOfTermPerYear)) -1;
                    var calculatedYear = {};




                    var formuePrimo = primo;
                    calculatedYear.BalancePrimo = formuePrimo;

                    var indskud = termDeposit;
                    calculatedYear.Deposit = indskud;

                    var primoFormueEfterIndskud = 0;
                    var omkIalt = 0;
                    var formueFørOmkOgSkat = 0;
                    var omkKontoInvest = 0;
                    var AvgBalance = 0;
                    var gain = 0;
                    var gains = 0;
                    for (var y = 0; y < noOfTermPerYear; y++) {
                        primoFormueEfterIndskud = formuePrimo + indskud;

                        gain = primoFormueEfterIndskud * currentInterestPct;
                        gains += gain;

                        formueFørOmkOgSkat = primoFormueEfterIndskud + gain;
                        calculatedYear.BalancePreCostAndTax = formueFørOmkOgSkat;

                        AvgBalance = ((primoFormueEfterIndskud + formueFørOmkOgSkat) / 2);
                        omkKontoInvest = AvgBalance * baseCost;
                        calculatedYear.Costs = omkKontoInvest;

                        omkIalt = omkKontoInvest;
                        calculatedYear.TotalCosts = omkIalt;

                        // new formuePrimo
                        formuePrimo = formueFørOmkOgSkat - omkIalt;
                    }
                    calculatedYear.Gains = gains;
                    calculatedYear.BalanceAfterDeposit = primoFormueEfterIndskud;
                    calculatedYear.Fees = 0;

                    var formueFørSkat = formueFørOmkOgSkat - omkIalt;
                    calculatedYear.BalancePreTax = formueFørSkat;

                    var taxBase = gain - omkKontoInvest;
                    var palSkat = taxBase * portfolio.Tax;

                    calculatedYear.Tax = palSkat;

                    var accountUltimo = formueFørSkat - palSkat;
                    calculatedYear.Ultimo = accountUltimo;

                    var GensFormueIndeForÅret = AvgBalance;
                    calculatedYear.AvgBalanceMedio = GensFormueIndeForÅret;
                    formuePrimo = accountUltimo;

                    return calculatedYear;
                },
                calculate: function (initialCapital, yearlyDeposit, portFolioIndex, numberOfYears) {
                    let useMonthlyPayment = configInformation[0].yearlyDeposit.useMonthlyPayment;
                    let numberOfTermPerYear = useMonthlyPayment ? 12 : 1;
                    let YearsArray = new Array(numberOfYears);
                    let portFolio = this.portfolios[portFolioIndex];
                    let primo = initialCapital;
                    if(useMonthlyPayment)
                    {

                        for (let j = 1; j <= numberOfYears; j++) {
                            YearsArray[j - 1] = this.calculateMonthly(portFolio, yearlyDeposit, primo, j);
                            primo = YearsArray[j - 1].Ultimo;
                        }
                    }
                    else
                    {
                        for (let j = 1; j <= numberOfYears; j++) {
                            YearsArray[j - 1] = this.calculateYearly(portFolio, yearlyDeposit, primo, j);
                            primo = parseInt(YearsArray[j - 1].Ultimo);
                        }
                    }

                    let totalDeposit = initialCapital + (numberOfYears * yearlyDeposit * numberOfTermPerYear);
                    let totalGains = 0;
                    let totalTax = 0;
                    let totalCosts = 0;
                    let totalAvgBalanceMedio = 0;
                    let yearsUltimo = new Array(YearsArray.length);



                    let firstYearCosts = 0.0;

                    for (var i = 0; i < portFolio.FeesLadder.length; i++) {
                        var feeStep = portFolio.FeesLadder[i];

                        var stepValue;

                        if (initialCapital > feeStep.LadderMax) {
                            stepValue = feeStep.LadderMax - feeStep.LadderMin;
                        } else if (initialCapital < feeStep.LadderMin) {
                            stepValue = 0;
                        } else {
                            stepValue = initialCapital - feeStep.LadderMin;
                        }

                        firstYearCosts += stepValue * feeStep.Cost;
                    }

                    // Base costs
                    firstYearCosts += initialCapital * portFolio.BaseCost;

                    for (let z = 0; z < YearsArray.length; z++) {
                        totalGains = totalGains + YearsArray[z].Gains;
                        totalTax = totalTax + YearsArray[z].Tax;
                        totalCosts = totalCosts + YearsArray[z].TotalCosts;
                        totalAvgBalanceMedio = totalAvgBalanceMedio + YearsArray[z].AvgBalanceMedio;
                        yearsUltimo[z] = YearsArray[z].Ultimo;
                    }

                    let avgBalanceMedio = totalAvgBalanceMedio / numberOfYears;

                    let result = {};
                    result.Years = yearsUltimo;
                    result.TotalDeposit = totalDeposit;
                    result.TotalGains = totalGains;
                    result.TotalTax = totalTax;
                    result.TotalCosts = totalCosts;
                    result.AvgYearlyCosts = totalCosts / numberOfYears;
                    result.YearlyCostsInPercentage = useMonthlyPayment ? portFolio.BaseCost : (result.AvgYearlyCosts / avgBalanceMedio);
                    result.FirstYearCosts = firstYearCosts;
                    result.FirstYearCostsPercentage = firstYearCosts / initialCapital;
                    result.EndBalance = YearsArray[numberOfYears - 1].Ultimo;

                    return result;
                },
                hidehumanValue: function (e) {/**when human friendly formattet value is clicked, hide it and show number input instead */
                    const numberInput = e.target.parentNode.getElementsByClassName('savings-graph-control__computerValue')[0];
                    numberInput.classList.add('savings-graph-control__computerValue--show');
                    numberInput.focus();
                },
                updateSliderValueFromInput: function (a) {/**update slider and chart when number input is changed*/
                    if (a.target.getAttribute('data-max') != null) {
                        let value = a.target.value * 1;
                        let dataMaxValue = a.target.getAttribute('data-max') * 1;
                        let currSlider = a.target.id.replace('savings-graph-control__computerValue--', '');
                        if (value > dataMaxValue) {
                            this.controllers[currSlider].customOptions.max = value;
                            this.controllers[currSlider].startValue = value;
                        } else {
                            this.controllers[currSlider].customOptions.max = dataMaxValue;
                            this.controllers[currSlider].startValue = value;
                        }

                        for (var prop in this.controllers[currSlider].customOptions) {
                            this.vueSliderOptionsinitialDeposit[prop] = this.controllers[currSlider].customOptions[prop];
                        }
                    }
                    this.sliderChange('fromInputField');
                },
                showhumanValue: function (e) {/**when leaving/blur on number input, show human friendly number again  */
                    e.target.classList.remove('savings-graph-control__computerValue--show');
                }
            },
            components: {
                'vueSlider': window['vue-slider-component']
            }
        });
    };

}();
